import { render, staticRenderFns } from "./VerifyGroupEmailInvitation.vue?vue&type=template&id=460116ac&"
import script from "./VerifyGroupEmailInvitation.vue?vue&type=script&lang=js&"
export * from "./VerifyGroupEmailInvitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports